import React, { useState, useEffect, useRef } from "react"
import styles from "./like.module.css"
import Storage from "@/lib/storage"
import ReCAPTCHA from "react-google-recaptcha"
import { requestArticleLike, fetchLikeCount } from "@/lib/api/like"
import { useSiteContext } from "@/lib/contexts/appContext"
import ThumbsUp from "@/common/icons/thumbsup"
import { Spinner } from "@/common/loading/spinner"
import classNames from "classnames"

export default function Like({ id }) {
  const [isLoading, setLoading] = useState(false)
  const [count, setCount] = useState(null)
  const [isLiked, setLiked] = useState(false)
  const [text, setText] = useState(null)
  const [status, setStatus] = useState(null)
  const context = useSiteContext()
  const recaptchaRef = useRef()
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY

  const doLike = async () => {
    if (isLoading) return

    setLoading(true)
    const action = isLiked ? "remove" : "add"
    const token = await recaptchaRef.current.executeAsync()
    const response = await requestArticleLike(context, id, action, token)
    let userLikes = Storage.get("likes", [])

    setStatus(response?.status)

    if (!response?.status || response?.status === "error") {
      setLoading(false)
      return
    }

    if (action === "add") {
      setLiked(true)
      userLikes.push(id)
    } else {
      setLiked(false)
      userLikes = userLikes.filter((like) => id !== like)
    }

    Storage.set("likes", userLikes)
    setCount(response.likes)
    setLoading(false)
  }

  useEffect(() => {
    if (count === null) return

    if (isLoading) {
      setText("Laddar...")
      return
    }

    if (status === "error") {
      setText("Något gick snett!")
      return
    }

    setText(
      parseInt(count, 10) === 0
        ? "Bli först att gilla!"
        : "Gillas av " + parseInt(count, 10)
    )
  }, [count, status, isLoading])

  useEffect(() => {
    setLoading(true)
    const userLikes = Storage.get("likes") || []
    setLiked(userLikes.includes(id))

    fetchLikeCount(context, id).then((response) => {
      setLoading(false)
      if (!response) {
        return
      }

      const { likes } = response
      setCount(parseInt(likes, 10))
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.wrapper}>
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={siteKey} />
      <div
        className={classNames("circle", {
          error: status === "error",
          liked: isLiked
        })}
        onClick={() => doLike()}>
        {isLoading && <Spinner />}
        {!isLoading && <ThumbsUp isLiked={status !== "error" && isLiked} />}
      </div>
      <div className="text">{text}</div>
    </div>
  )
}
